<div class="em-settings main-content">
    <router-outlet></router-outlet>
</div>